import React, { useEffect, useState } from "react";
import {
  Briefcase,
  MapPin,
  Wallet,
  UserRound,
  Phone
} from "lucide-react";
import API from "../../../api";
import "./WorkSuggestionRow.css";

export default function WorkSuggestionRow({ onConsult }) {
  const [workPosts, setWorkPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadWorkPosts();
  }, []);

  const loadWorkPosts = async () => {
    try {
      const res = await API.get("/work-posts");

      if (res.data.success) {
        setWorkPosts(res.data.workPosts || []);
      }
    } catch (err) {
      console.error("Work posts load failed:", err);
      setWorkPosts([]);
    } finally {
      setLoading(false);
    }
  };

  const getRemainingTime = (expiresAt) => {
  if (!expiresAt) return "";

  const diff =
    new Date(expiresAt).getTime() - Date.now();

  if (diff <= 0) return "Expired";

  const days = Math.floor(
    diff / (1000 * 60 * 60 * 24)
  );

  const hours = Math.floor(
    (diff % (1000 * 60 * 60 * 24)) /
      (1000 * 60 * 60)
  );

  if (days > 0) {
    return `${days} day${days > 1 ? "s" : ""} left`;
  }

  return `${hours} hour${hours !== 1 ? "s" : ""} left`;
};

  if (loading || !workPosts.length) {
    return null;
  }

  return (
    <section className="home-work-row">

      {/* ================= HEADER ================= */}

      <div className="home-work-row-header">

        <div className="home-work-title">

          <div className="home-work-icon">
            <Briefcase size={18} />
          </div>

          <div>
            <h3>Work Opportunities</h3>

            <p>
              Work opportunities from Civilink professionals
            </p>
          </div>

        </div>

      </div>

      {/* ================= WORK POSTS ================= */}

      <div className="home-work-scroll">

        {workPosts.map((work) => {

          const poster = work.postedBy || {};

          const location =
            work.location?.city ||
            "Location not specified";

          const budget =
            work.budget > 0
              ? `₹${Number(work.budget).toLocaleString("en-IN")}`
              : "Budget not specified";

          const skills =
            Array.isArray(work.skills)
              ? work.skills.slice(0, 3)
              : [];

          return (
            <div
              key={work._id}
              className="home-work-card"
            >

              {/* ================= TITLE ================= */}

              <div className="home-work-card-top">

                <div className="home-work-card-icon">
                  <Briefcase size={20} />
                </div>

                <div className="home-work-card-title">

                  <h4>
                    {work.title}
                  </h4>

                  <span>
                    {work.workType || "Work"}
                  </span>

                </div>

              </div>

              {/* ================= POSTER ================= */}

              <div className="home-work-person">

                <div className="home-work-avatar">

                  {poster.profilePhoto ? (
                    <img
                      src={poster.profilePhoto}
                      alt=""
                    />
                  ) : (
                    <UserRound size={18} />
                  )}

                </div>

                <div>

                  <strong>
                    {poster.name || "Civilink User"}
                  </strong>

                  {poster.profession && (
                    <span>
                      {poster.profession}
                    </span>
                  )}

                </div>

              </div>

              {/* ================= LOCATION ================= */}

              <div className="home-work-detail">

                <MapPin size={15} />

                <span>
                  {location}

                  {work.location?.state
                    ? `, ${work.location.state}`
                    : ""}
                </span>

              </div>

              {/* ================= BUDGET ================= */}

              <div className="home-work-detail">

                <Wallet size={15} />

                <span>
                  {budget}

                  {work.budgetType &&
                  work.budget > 0
                    ? ` • ${work.budgetType}`
                    : ""}
                </span>

              </div>

              {/* ================= EXPIRY ================= */}

<div className="home-work-expiry">
  {getRemainingTime(work.expiresAt)}
</div>

              {/* ================= SKILLS ================= */}

              {skills.length > 0 && (

                <div className="home-work-skills">

                  {skills.map((skill, index) => (
                    <span key={index}>
                      {skill}
                    </span>
                  ))}

                </div>

              )}

              {/* ================= CONSULT ================= */}

              <button
                className="home-work-consult-btn"
                onClick={() => {

                  if (!localStorage.getItem("token")) {
                    return;
                  }

                  if (!poster?._id) {
                    alert(
                      "Unable to contact this professional."
                    );
                    return;
                  }

                  onConsult?.(poster);

                }}
              >
                <Phone size={15} />
                Consult
              </button>

            </div>
          );
        })}

      </div>

    </section>
  );
}